import { magento } from "@magento/clients/getClient";
import type { IRegion } from "@magento/types";

import { useQuery } from "@jti/rest-api";

type UseRegionsResult = {
  regions: Required<Pick<IRegion, "id" | "code" | "name">>[];
  isLoadingRegions: boolean;
};

export const useRegions = (countryId: string, enabled: boolean = true): UseRegionsResult => {
  const { data, isLoading } = useQuery(["getCountry", countryId], () => magento.getCountry(countryId), {
    enabled,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  const regions = (data?.country?.available_regions ?? []).filter((region) =>
    Boolean(region?.id && region?.code && region?.name)
  );

  return {
    regions,
    isLoadingRegions: isLoading,
  };
};
